import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { getFullPath } from '../lib/get-full-path';
import { BrowserService } from '../services/browser.service';
import { RedirectService } from '../services/redirect.service';

export const tenantAuthGuard: CanActivateFn = route => {
  const redirectService = inject(RedirectService);
  const browserService = inject(BrowserService);

  const path = getFullPath(route);
  const query = route.queryParams;

  let url = browserService.getCorrectPicflowUrl();
  if (path.length) url += `/${path.join('/')}`;
  const queryString = new URLSearchParams(query).toString();
  if (queryString) url += `?${queryString}`;

  return redirectService.externalRedirectTo(url);
};
